import type { PlatformAdapter } from "./PlatformAdapter";
import type { HapticStyle, PlayerProfile, SaveData } from "../core/types";
import { DEFAULT_SAVE } from "../core/types";

const SAVE_KEY = "td_save_v1";

/** Local-dev / standalone-web adapter. Persists to localStorage. */
export class WebAdapter implements PlatformAdapter {
  readonly name = "web";

  async init(): Promise<void> {
    // nothing to do
  }

  getPlayer(): PlayerProfile {
    let id = localStorage.getItem("td_local_id");
    if (!id) {
      id = `web_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("td_local_id", id);
    }
    return { id, username: "Player" };
  }

  async load(): Promise<SaveData> {
    const raw = localStorage.getItem(SAVE_KEY);
    if (!raw) return { ...DEFAULT_SAVE };
    try {
      return { ...DEFAULT_SAVE, ...JSON.parse(raw) };
    } catch {
      return { ...DEFAULT_SAVE };
    }
  }

  async save(data: SaveData): Promise<void> {
    localStorage.setItem(SAVE_KEY, JSON.stringify(data));
  }

  haptic(_style: HapticStyle): void {
    // no haptics on plain web
  }

  async share(text: string): Promise<void> {
    if (navigator.share) {
      try {
        await navigator.share({ text });
      } catch {
        /* user cancelled */
      }
      return;
    }
    await navigator.clipboard?.writeText(text);
  }

  async showRewardedAd(): Promise<{ rewarded: boolean }> {
    // stub: simulate a rewarded ad in dev
    console.log("[WebAdapter] (stub) rewarded ad");
    return { rewarded: true };
  }

  async purchase(productId: string): Promise<{ success: boolean }> {
    console.log("[WebAdapter] (stub) purchase", productId);
    return { success: false };
  }

  getViewport() {
    return { width: window.innerWidth, height: window.innerHeight };
  }
}
